require('./bootstrap');

require('alpinejs');

import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

window.axios = require('axios');
window.Vue = require('vue');

// Quill editor
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.config.productionTip = false;

// Initialize and use Vuetify
const vuetifyOptions = {};
Vue.use(Vuetify);

Vue.use(VueQuillEditor);

Vue.component('lmsenrollmentaudit-index-component', require('./components/LmsEnrollmentAuditIndexComponent.vue').default);
Vue.component('licensureactivestudents-index-component', require('./components/LicensureActiveStudentsIndexComponent.vue').default);
Vue.component('courseassistants-index-component', require('./components/CourseAssistantsIndexComponent.vue').default);
Vue.component('lmsmarkers-index-component', require('./components/LmsMarkersIndexComponent.vue').default);
Vue.component('genedcourses-index-component', require('./components/gened/GenedCoursesIndexComponent.vue').default);
Vue.component('courses-table',  require('./components/CoursesTable.vue').default);

import XLSX from 'xlsx';
Vue.use(XLSX);
require('xlsx');

import VueFlashMessage from 'vue-flash-message';
Vue.use(VueFlashMessage);
require('vue-flash-message/dist/vue-flash-message.min.css');

const app = new Vue({
    el: '#app',
    icons: {
        iconfont: 'mdi',
    },
    vuetify: new Vuetify(vuetifyOptions),
});
